export const getTargetInbox = (segment) => segment === "evergabe" ? "vergabe@bi-medien.de" : "abo@bi-medien.de"
